import { observer } from 'mobx-react-lite'

import { MonthTermInstallment } from 'widgets/mplus/mplus-payment/component'

import { MinstallmentInfo } from 'entities/mplus/module'
import userStore from 'entities/user/module/user-store'

import { COUNT_MONTH_MPLUS, isShowingMplus } from 'shared/constants'

import { MinstallmentText } from '../minstallment-text'
import { MplusText } from '../mplus-text'

interface Props {
  price?: string
  tranche?: string
  mInstallmentInfo: MinstallmentInfo
}

export const TagPayment = observer(
  ({ price, tranche, mInstallmentInfo }: Props) => {
    const isMplusAvailableForUser = userStore.userSettings?.is_mplus_available
    const isMInstalmentAvailable =
      userStore.userSettings?.is_minstallment_available

    const parsedPrice = Number(price || '0')
    const isMplusAvailable =
      isShowingMplus && tranche && isMplusAvailableForUser

    if (!isMplusAvailable) return

    if (price === undefined) return null

    if (
      isMplusAvailable &&
      parsedPrice < MonthTermInstallment.firstMeridian.priceOfTicket
    ) {
      return (
        <MplusText
          tranche={tranche}
          month={COUNT_MONTH_MPLUS}
        />
      )
    }

    if (
      isMInstalmentAvailable &&
      parsedPrice >= MonthTermInstallment.firstMeridian.priceOfTicket
    ) {
      return (
        <MinstallmentText
          month={mInstallmentInfo?.month}
          tranche={mInstallmentInfo?.monthly_payment}
        />
      )
    }

    return null
  },
)
